import { TABLE_SELECTION_WIDTH } from './constants';
var ResizableColumnsUtils = /** @class */ (function () {
    function ResizableColumnsUtils(table) {
        this.table = table;
        this.node = this.table.node;
    }
    ResizableColumnsUtils.findClosestParent = function (element, tagName) {
        while (element) {
            if (element.tagName === tagName.toUpperCase()) {
                return element;
            }
            element = element.parentElement;
        }
    };
    ResizableColumnsUtils.prototype.getRootElement = function () {
        return this.node.querySelector('.awsui-table-inner');
    };
    ResizableColumnsUtils.prototype.getTable = function () {
        return this.node.querySelector('.awsui-table-container > table');
    };
    ResizableColumnsUtils.prototype.getContainer = function () {
        return this.getTable().parentElement;
    };
    ResizableColumnsUtils.prototype.getThead = function () {
        return this.getTable().querySelector('thead');
    };
    ResizableColumnsUtils.prototype.getTracker = function () {
        return this.node.querySelector('.awsui-table-resizable-columns-resizer-tracker');
    };
    ResizableColumnsUtils.prototype.getResizer = function (column) {
        return column.querySelector('.awsui-table-resizable-columns-resizer');
    };
    ResizableColumnsUtils.prototype.getColumn = function (id) {
        return this.getTable().querySelector("th[data-awsui-column-id=\"" + id + "\"]");
    };
    ResizableColumnsUtils.prototype.getColumnWithStickyHeader = function (id) {
        return Array.prototype.slice.call(this.node.querySelectorAll("th[data-awsui-column-id=\"" + id + "\"]"));
    };
    ResizableColumnsUtils.prototype.getResizableColumns = function () {
        return Array.prototype.slice.call(this.getTable().querySelectorAll('th'));
    };
    ResizableColumnsUtils.prototype.getLastColumn = function () {
        var columns = this.getResizableColumns();
        return columns[columns.length - 1];
    };
    ResizableColumnsUtils.prototype.getStylePixel = function (pixel) {
        return parseFloat(pixel);
    };
    ResizableColumnsUtils.prototype.setStylePixel = function (pixel) {
        return pixel + "px";
    };
    ResizableColumnsUtils.prototype.getEdgePosition = function (node, edge) {
        // IE returns decimal values, we need to round them down to be calculated correctly
        return Math.floor(node.getBoundingClientRect()[edge]);
    };
    ResizableColumnsUtils.prototype.getColumnWidths = function (columnWidths) {
        return Object.keys(columnWidths).map(function (key) { return columnWidths[key]; });
    };
    ResizableColumnsUtils.prototype.getTableWidth = function (columnWidths, shrinkLastColumn) {
        var _this = this;
        if (shrinkLastColumn === void 0) { shrinkLastColumn = false; }
        var isSelectionEnabled = !!this.table.__selection;
        var visibleColumnIds = this.getResizableColumns().map(function (column) { return column.getAttribute('data-awsui-column-id'); });
        var tableWidth = visibleColumnIds.slice(0, -1).reduce(function (width, id) {
            var minWidth = _this.getStylePixel(_this.getColumn(id).style.minWidth);
            return width + Math.max(columnWidths[id], minWidth);
        }, 0);
        var lastColumn = this.getColumn(visibleColumnIds[visibleColumnIds.length - 1]);
        if (lastColumn) {
            var lastColumnWidth = shrinkLastColumn ? this.getStylePixel(lastColumn.style.minWidth) : lastColumn.offsetWidth;
            tableWidth += Math.max(lastColumnWidth, columnWidths[visibleColumnIds[visibleColumnIds.length - 1]]);
        }
        if (isSelectionEnabled) {
            tableWidth += TABLE_SELECTION_WIDTH;
        }
        return tableWidth;
    };
    ResizableColumnsUtils.prototype.isEqualWidths = function (prevColumnWidths, columnWidths) {
        var keys = Object.keys(prevColumnWidths);
        return keys.every(function (key) { return prevColumnWidths[key] === columnWidths[key]; });
    };
    return ResizableColumnsUtils;
}());
export default ResizableColumnsUtils;
//# sourceMappingURL=utils.js.map